export const getAnalyticsEventUrl = () => 'analytics/event'
export const getChangeAnalyticsContextUrl = () => 'analytics/context'

export const getAnalyticsUserOverviewUrl = () => 'analytics/user/overview'
export const getAnalyticsUserContentChartUrl = () => 'analytics/user/content/chart'
export const getAnalyticsUserContentAudioUrl = () => 'analytics/user/content/audio'
export const getAnalyticsUserContentCollectionsUrl = () => 'analytics/user/content/collections'
export const getAnalyticsUserAudienceUrl = () => 'analytics/user/audience'
export const getAnalyticsUserEarningsUrl = () => 'analytics/user/earnings'
export const getAnalyticsUserPromoPagesUrl = () => 'analytics/user/promo-pages'
